import { Diagnosis } from "@prisma/client"

export const getExerciseVisibleList = (diagnoses: { diagnose: Diagnosis }[]) => {
    const visibleDiagnoses = diagnoses.slice(0, 2)
    const notVisibleCount = diagnoses.slice(2).length

    return { visibleDiagnoses, notVisibleCount }
}
